<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div v-if="permission2.checkCustomer || permission.addCustomer || permission.editCustomer" class="search-name">客户</div>
                <el-select
                    v-if="permission2.checkCustomer || permission.addCustomer || permission.editCustomer"
                    size="small"
                    class="search-item"
                    style="width: 160px"
                    :loading="selLoading"
                    v-model="searchData.EntpCusId"
                    filterable
                    clearable
                    placeholder="选择客户"
                    remote
                    reserve-keyword
                    :remote-method="searchCustomer"
                    @visible-change="customerVisibleChange($event)"
                >
                    <el-option
                        v-for="optionItem in customerList"
                        :key="optionItem.EntpCusId"
                        :data-msg="optionItem"
                        :label="optionItem.EntpCusName"
                        :value="optionItem.EntpCusId"
                    ></el-option>
                </el-select>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select
                        size="small"
                        style="width: 140px"
                        :loading="selLoading"
                        v-model="searchData.BrandName"
                        filterable
                        clearable
                        @visible-change="brandVisibleChange($event)"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select size="small" style="width: 140px" :loading="selLoading" v-model="searchData.Cate" filterable clearable @visible-change="cateVisibleChange($event)">
                        <el-option label="全部" value></el-option>
                        <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                            <div class="option-content">
                                <div>{{ optionItem.Text }}</div>
                            </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name">提交时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch" style="height: 32px">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch" style="height: 32px">重置</el-button>
                <el-button size="small" v-if="isCanTBSet" icon="el-icon-setting" class="search-btn" type="primary"  @click="showTableSetDialog" style="height: 32px;background-color:#409EFF;">表格设置</el-button>
            </div>
        </div>
        <div>
            <el-card class="box-card">
                <div class="data-count">
                    <div class="data-item">
                        <p>平均</p>
                        <p>{{ avg }}</p>
                    </div>
                    <div class="data-item" v-for="(stat, index) in statData" :key="index">
                        <p>
                            {{ month - index > 0 ? year : year - 1 }} -
                            {{ month - index > 0 ? month - index : month - index + 12 }}
                        </p>
                        <p>{{ stat }}</p>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%; margin-bottom: 0px">
                <!-- <el-table-column width="180px" prop="OrderCode" label="订单号" show-overflow-tooltip></el-table-column>
                <el-table-column
                    v-if="permission2.checkCustomer || permission.addCustomer || permission.editCustomer"
                    prop="EntpCusName"
                    label="客户"
                    min-width="200px"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column min-width="140px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="140px" prop="EntpTempGoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="140px" prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Count" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="Origin" label="产地"></el-table-column>
                <el-table-column show-overflow-tooltip width="120px" prop="StoName" label="出/入仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Price" label="售价"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="SName" label="业务员"></el-table-column>
                <el-table-column show-overflow-tooltip width="110px" prop="SubmitTime" label="下单时间"></el-table-column> -->
                <template v-for="(item,index) in columnShowSets">
                    <el-table-column
                        v-if="item.ColumnCode != 'EntpCusName'"
                        v-bind:key="item.ColumnCode + index"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :prop="item.ColumnCode"
                        :label="item.ColumnName" 
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-else-if="permission2.checkCustomer || permission.addCustomer || permission.editCustomer"
                        v-bind:key="item.ColumnCode + index"
                        :width="item.Width > 0 ? item.Width + 'px' : '150px'"
                        :prop="item.ColumnCode"
                        :label="item.ColumnName" 
                        show-overflow-tooltip
                    ></el-table-column>
                </template>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="提交时间" :visible.sync="timeVisible" :append-to-body="true" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <!-- 自定义列 -->
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import timePicker from '@/components/common/timePicker';
import tableSets from '@/components/common/tableSets_v2.vue';
export default {
    name: '',
    props: {
        EntpTempGoodsId: {
            type: String
        },
        EntpCusId: {
            type: String
        },
        EntpCusName: {
            type: String
        },
        NoInit: {
            type: Boolean
        }
    },
    components: { 
        timePicker,
        tableSets
    },
    data() {
        return {
            loading: false,
            selLoading: false,
            typeList: [],
            brandList: [],
            customerList: [],
            isCanTBSet: false,
            tableCode: 'SaleHistory',
            columnShowSets:[],
            tableSetsVisible:false,
            searchData: {
                OrderType:"1",
                GoodsId: this.EntpTempGoodsId,
                EntpCusId: this.EntpCusId,
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            },
            statData: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            permission2: {},
            timeVisible: false,
            avg: 0,
            month: 0,
            year: 0
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('salesOrder');
        this.permission2 = this.$util.getPermission('supplierBuyOrder');

        if (this.EntpCusId) {
            this.customerList.push({
                EntpCusId: this.EntpCusId,
                EntpCusName: this.EntpCusName
            });
        }
        if (this.tableCode) {
            this.getConfigByCodes();
            this.getSetsData();
        }
        this.year = new Date().getFullYear();
        this.month = new Date().getMonth() + 1;
        if (!this.NoInit) this.getTableData();
    },
    methods: {
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['ygsfkzdylb'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'ygsfkzdylb': //是否可自定义列表
                                    this.isCanTBSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        closeDialog(isEdit) {
            this.tableSetsVisible = false;
            if(isEdit){
                this.$router.go(0);
            }
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.EntpCusId && !that.searchData.EntpCusId) {
                    if (that.customerList.length == 1) that.searchCustomer('');
                } else {
                    if (that.customerList.length == 0) that.searchCustomer('');
                }
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            this.selLoading = true;
            this.$util
                .searchCustomer(key)
                .then(data => {
                    this.customerList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                OrderType:"1",
                GoodsId: this.EntpTempGoodsId,
                EntpCusId: this.EntpCusId,
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 10,
                StartDate: '',
                EndDate: ''
            };
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 更新表格数据
        updateTableData(id) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetGoodsSaleHistoriesList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = {};
                    this.tableData = data.SaleData;
                    this.tableDataLength = res.count;
                    this.statData = data.StatData;
                    this.avg = data.Avg;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
.search-ctn {
    .search-ctn-left {
        margin-top: 5px;
        .search-name,
        .search-item,
        button {
            margin-bottom: 10px;
        }
    }
    .search-btn,
    .search-item {
        margin-bottom: 0;
    }
}
</style>
